import React, { useEffect, useState } from 'react';
import './ResumoFinanceiroMeta.css';

function ResumoFinanceiroMeta() {
  const [dados, setDados] = useState(null);
  const [carregando, setCarregando] = useState(false);
  const [erro, setErro] = useState('');
  const [usuarios, setUsuarios] = useState([]);
  const [usuarioSelecionado, setUsuarioSelecionado] = useState('');
  const usuario = JSON.parse(localStorage.getItem('usuario')) || {};
  const isMaster = usuario.tipo_usuario === 'master';

  useEffect(() => {
    if (isMaster) {
      fetch('https://welaunchyou.com.br/crm-wly/api/integracoes/meta_listar_vinculo.php', {
        credentials: 'include'
      })
        .then((res) => res.json())
        .then((data) => {
          const usuariosUnicos = Object.values(
            (data.data || []).reduce((acc, item) => {
              acc[item.usuario_id] = {
                id: item.usuario_id,
                nome_empresa: item.facebook_page_name || `Cliente #${item.usuario_id}`
              };
              return acc;
            }, {})
          );
          setUsuarios(usuariosUnicos);
        })
        .catch((err) => console.error('Erro ao carregar usuários:', err));
    }
  }, [isMaster]);

  useEffect(() => {
    async function carregarResumo() {
      setCarregando(true);
      setErro('');
      setDados(null);

      try {
        let url = 'https://welaunchyou.com.br/crm-wly/api/integracoes/meta_resumo_financeiro.php';
        if (isMaster && usuarioSelecionado) {
          url += `?usuario_id=${usuarioSelecionado}`;
        }

        const response = await fetch(url, {
          credentials: 'include',
        });
        const data = await response.json();

        if (data.success) {
          setDados(data.data);
        } else {
          setErro(data.error || 'Erro ao carregar dados.');
        }
      } catch (err) {
        setErro('Erro ao conectar com o servidor.');
      } finally {
        setCarregando(false);
      }
    }

    if (!isMaster || (isMaster && usuarioSelecionado)) {
      carregarResumo();
    }
  }, [usuarioSelecionado, isMaster]);

  const formatarMoeda = (valor) =>
    Number(valor || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

  const formatarDataHora = (dataUTC) => {
    const data = new Date(dataUTC);
    return data.toLocaleString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className="resumo-financeiro-meta-container">
      <h1 className="titulo">Resumo Financeiro da Conta de Anúncios</h1>

      {isMaster && (
        <div style={{ marginBottom: '30px' }}>
          <label>Selecionar Cliente:</label>
          <select
            value={usuarioSelecionado}
            onChange={(e) => setUsuarioSelecionado(e.target.value)}
          >
            <option value="">-- Escolha um cliente --</option>
            {usuarios.map((u) => (
              <option key={u.id} value={u.id}>
                {u.nome_empresa}
              </option>
            ))}
          </select>
        </div>
      )}

      {carregando && <p>Carregando resumo financeiro...</p>}
      {erro && <p style={{ color: 'red' }}>Erro: {erro}</p>}

      {dados && (
        <>
          <div className="cards">
          
          <div className="card">
  <h2 style={{ borderBottom:"none", textAlign:"center" }}>Saldo</h2>

  {dados.tipo_pagamento === 'pre' && (
    <>
      <p>{formatarMoeda(dados.info_conta.saldo_pre_pago)}</p>
      <small>
        <strong>PRÉ-PAGA:</strong> Este valor representa o saldo <strong>aproximado</strong> disponível.
      </small>
    </>
  )}

  {dados.tipo_pagamento === 'pos' && (
    <>
      <p>{formatarMoeda(dados.info_conta.saldo_devedor_cartao)}</p>
      <small>
        <strong>PÓS-PAGA:</strong> Representa o valor devedor no cartão.
      </small>
    </>
  )}
</div>

            <div className="card" style={{ borderBottom: 'none' }}>
              <h2>Investido Últimos 7 Dias</h2>
              <p>{formatarMoeda(dados.gasto_7_dias)}</p>
            </div>

            <div className="card" style={{ borderBottom: 'none' }}>
              <h2>Investido Mês Atual</h2>
              <p>{formatarMoeda(dados.gasto_mes)}</p>
            </div>

            <div className="card" style={{ borderBottom: 'none' }}>
              <h2>Conta</h2>
              <p>{dados.info_conta?.name}</p>
              <small>
                Nº Conta: <strong>{dados.info_conta?.ad_account_id?.replace('act_', '')}</strong><br />
                Status: {dados.info_conta?.account_status === 1 ? 'Ativa' : 'Inativa/Restrita'}
              </small>
            </div>
          </div>

          {/* 🔻 Tabela de Transações */}
          {dados.transacoes?.length > 0 && (
            <div style={{ marginTop: '40px' }}>
              <h1 className="titulo" style={{ borderBottom: 'none', marginBottom: '20px'}}>Últimas Transações</h1>
              <table style={{
                width: '100%',
                borderCollapse: 'collapse',
                fontSize: '14px'
              }}>
                <thead>
                  <tr style={{ background: '#f0f0f0' }}>
                    <th style={{ padding: '10px', border: '1px solid #ddd' }}>Data</th>
                    <th style={{ padding: '10px', border: '1px solid #ddd' }}>Tipo</th>
                  </tr>
                </thead>
                <tbody>
                  {dados.transacoes.map((transacao, index) => (
                    <tr key={index}>
                      <td style={{ padding: '10px', border: '1px solid #ddd' }}>
                        {formatarDataHora(transacao.event_time)}
                      </td>
                      <td style={{ padding: '10px', border: '1px solid #ddd' }}>
                        {transacao.event_type === 'ad_account_billing_charge' ? 'Cobrança de Anúncio' : transacao.event_type}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default ResumoFinanceiroMeta;
